<template>
    <div class="animated fadeIn">
        <b-card>
            <h5 class="mb-0"><i class="fa fa-fw fa-pencil mr-2" />Input Upload / Video</h5>
            <hr />
            <b-row align-v="center">
                <b-col md="4">
                    <b-form-group label="IMEI / No. Faktur PGI">
                        <b-input-group>
                            <b-input v-model="number" maxlength="60" @keydown.enter="searchNumber"
                                :disabled="!!inventoryId || isSubmitting" />

                            <b-input-group-append>
                                <b-button variant="primary" @click="searchNumber"
                                    :disabled="!!inventoryId || isSubmitting">
                                    <i class="fa fa-fw fa-search mr-2" />Cari
                                </b-button>
                                <!-- Reset -->
                                <b-button class="ml-2" variant="outline-danger" @click="onReset">
                                    <i class="fa fa-fw fa-times mr-2" />Reset
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>

                </b-col>

            </b-row>

            <div v-if="item && inventoryId">
                <b-row class="mt-3">
                    <b-col md="6">
                        <div class="font-weight-bold">Jenis Barang</div>
                        {{ item.kind }}
                        <div class="font-weight-bold mt-3">Merk Barang</div>
                        {{ item.brand }}
                        <div class="font-weight-bold mt-3">Tipe Barang</div>
                        {{ item.type }}
                        <div class="font-weight-bold mt-3">Tahun / Generasi Barang</div>
                        {{ item.year || "-" }}
                    </b-col>
                    <b-col md="6">
                        <div class="font-weight-bold">No. Faktur PGI</div>
                        {{ item.no_faktur }}
                        <div class="font-weight-bold mt-3">IMEI / SN</div>
                        {{ item.imei_sn }}
                        <div class="font-weight-bold mt-3">Password</div>
                        {{ item.password || "-" }}
                        <div class="font-weight-bold mt-3">Grade / Kelengkapan dari PGI</div>
                        {{ item.grade_pgi || "-" }} / {{ item.is_batangan_pgi == 1 ? "Batangan" : "Lengkap" }}
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <b-row class="mt-2">
                            <b-col md="2">
                                <b-select class="mt-3" v-model="kategoriFoto" :options="kategoriFotoOpt" />
                            </b-col>
                            <b-col>
                                <b-button class="mt-3" variant="primary" @click="addPhoto">
                                    <i class="fa fa-fw fa-plus mr-2" />Tambah Bagian
                                </b-button>
                            </b-col>

                            <b-col class="d-flex justify-content-end mt-3">
                                <b-button variant="dark" v-b-tooltip.hover.top title="Adjustment Barang"
                                    @click="prepareAdjustment()">
                                    <i class="fa fa-fw fa-wrench" /> Adjustment Kerusakan
                                </b-button>
                                <b-button class="ml-2" variant="dark" v-b-tooltip.hover.top title="Reprint Barcode"
                                    @click="prepareReprint()">
                                    <i class="fa fa-fw fa-barcode" /> Reprint Barcode
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col v-for="(photo, index) in photos" :key="photo.id" md="6">
                                <div class="upload-section mt-2">
                                    <div class="d-flex justify-content-between">
                                        <p>{{ photo.name }}</p>
                                        <b-button v-if="!photo.isRequired"
                                            @click="confirmAction(index, photo, 'delete')" variant="outline-danger"
                                            size="sm" class="delete-button">
                                            <i class="fa fa-fw fa-trash" />
                                        </b-button>
                                    </div>
                                    <b-row class="mt-2">
                                        <b-col md="12">
                                            <div class="preview-photo">

                                                <div v-if="!photo.isVideo">
                                                    <img :id="photo.url" @click="showPreview(index)"
                                                        v-if="photo.file != null" :src="photo.url" alt="preview" />
                                                    <p :id="photo.url" @click="showPreview(index)" v-else-if="photo.url"
                                                        style="cursor:pointer;font-weight: bold"
                                                        class="font-weight-bold">
                                                        <i class="fa fa-eye mr-2" />Lihat Foto
                                                    </p>
                                                    <p v-else class="mt-2">No Photo</p>
                                                </div>

                                                <div v-if="photo.isVideo">
                                                    <video v-if="photo.file != null" width="100%" controls
                                                        @click="showPreview(index)">
                                                        <source :src="photo.url" type="video/mp4">
                                                        Your browser does not support the video tag.
                                                    </video>
                                                    <p :id="photo.url" @click="showPreview(index)" v-else-if="photo.url"
                                                        style="cursor:pointer" class="font-weight-bold">
                                                        <i class="fa fa-eye mr-2" />
                                                        Lihat Video
                                                    </p>
                                                    <p v-else class="mt-2">No Video</p>
                                                </div>
                                            </div>
                                        </b-col>
                                        <b-col md="12">
                                            <div class="mt-2"
                                                style="display: flex; flex-direction: column;gap: 3px; justify-content: center;">

                                                <!-- <b-button v-if="!photo.isVideo" variant="outline-primary"
                                                    @click="onCapture(index)">
                                                    <i class="fa fa-fw fa-camera" />
                                                    Capture
                                                </b-button> -->

                                                <span v-show="!isUpload" :id="'uploadFile-' + index"
                                                    class="custom-file-upload my-2">
                                                    <i class="fa fa-fw fa-upload" />
                                                    Browse
                                                </span>

                                                <div :id="uploadKey">
                                                    <uploading style="width:100%"
                                                        v-if="fileUploadResumable[index] && fileUploadResumable[index].status == 'uploading'"
                                                        :completedSteps="fileUploadResumable[index].progress" />

                                                    <div v-if="fileUploadResumable[index] && fileUploadResumable[index].status == 'finalizing'"
                                                        class="text-center">Sedang proses finalisasi, mohon menunggu...
                                                    </div>


                                                    <div v-if="fileUploadResumable[index] && fileUploadResumable[index].status == 'retry'"
                                                        class="text-center">
                                                        Sedang menghubungkan kembali, mohon menunggu...
                                                    </div>

                                                    <div v-if="fileUploadResumable[index] && fileUploadResumable[index].status == 'error'"
                                                        class="text-center">
                                                        Mengalami kesalahan, silahkan coba lagi.
                                                    </div>
                                                </div>

                                                <!-- <b-button variant="outline-primary" :disabled="photo.isUploaded"
                                                    @click="onSavePhoto(index)">
                                                    <i class="fa fa-fw fa-save" />
                                                    {{ photo.isUploaded ? "Uploading..." : "Save" }}
                                                </b-button> -->
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <!-- <div class="d-flex">
                                        <div class="preview-photo">
                                            <img :id="photo.url" @click="showPreview(index)" v-if="photo.url"
                                                :src="photo.url" alt="preview" />
                                            <p v-else class="mt-2">No Photo</p>
                                        </div>
                                    </div> -->
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>

            <div v-if="isSubmitting" class="d-flex justify-content-center mt-3">
                <b-spinner label="Loading..." />
            </div>

        </b-card>


        <b-modal id="m-preview-photo" title="Preview Foto" hide-footer>
            <div v-if="previewPhoto">
                <img v-if="!previewPhoto.isVideo" :src="previewPhoto.url" alt="preview"
                    style="max-width: 100%; max-height: 100%; object-fit: contain;" />
                <video v-else controls style="max-width: 100%; max-height: 100%; object-fit: contain;">
                    <source :src="previewPhoto.url" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
        </b-modal>

        <b-modal v-if="activeItem" id="m-item-to-adjust" title="Adjustment Barang Masuk" size="xl" centered
            no-close-on-backdrop no-close-on-esc hide-footer>
            <div>
                <b-table bordered hover show-empty no-local-sorting :items="invoiceAdjustments" :fields="fieldsAdjust"
                    responsive class="my-4">
                    <template v-slot:empty>
                        Tidak ada adjustment.
                    </template>
                    <template v-slot:cell(category)="row">
                        <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                        <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                        <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                        <b-form-select v-model="row.item.category" :options="optCategory"
                            @change="onChangeRowCategory(row.index)"
                            :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)" />
                    </template>
                    <template v-slot:cell(name)="row">
                        <!-- <b-form-input v-model="row.item.name" maxlength="50" /> -->
                        <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                        <!-- <b-form-select v-model="row.item.adjustmentSelect" :options="optAdjustments" @change="onChangeAdjustmentSelect($event, row.index)" /> -->
                        <b-form-select v-model="row.item.adjustmentSelect" :options="row.item.optAdjustments"
                            @change="changeAdjustment"
                            :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment)" />
                        <small class="text-muted"
                            v-if="row.item.adjustmentSelect === null || row.item.adjustmentSelect.id == null">{{
                                row.item.name_placeholder }}</small>
                    </template>
                    <template v-slot:cell(adjustment)="row">
                        <b-input-group prepend="Rp.">
                            <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                            <!-- <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)" disabled></b-form-input> -->
                            <b-form-input v-model="row.item.adjustment" @input="sanitize(row.item)"
                                :disabled="(row.item.adjustmentPercentage != '' && row.item.adjustmentPercentage != null) || activeItem.status == '3'"></b-form-input>
                        </b-input-group>
                    </template>
                    <template v-slot:cell(adjustmentPercent)="row">
                        <b-input-group append="%">
                            <!-- diubah sementara supaya adjustment harga bisa diinput manual dulu -->
                            <!-- <b-form-input v-model="row.item.adjustmentPercentage" disabled></b-form-input> -->
                            <b-form-input v-model="row.item.adjustmentPercentage" @input="changeAdjustment"
                                :disabled="(row.item.adjustment != '' && row.item.adjustment != null) || activeItem.status == '3'"></b-form-input>
                        </b-input-group>
                    </template>
                    <template v-slot:cell(action)="row">
                        <div class="d-flex">
                            <b-button size="sm" variant="dark" v-b-tooltip.hover.top title="Gambar Kerusakan"
                                :disabled="$helper.isBlank(row.item.adjustmentSelect) || isSubmitting"
                                @click="prepareAdjImage(row.item)">
                                <i class="fa fa-fw fa-picture-o" />
                            </b-button>
                            <b-button variant="danger" size="sm" class="ml-2" v-b-tooltip.hover.top title="Hapus"
                                :disabled="activeItem.status == '3'" @click="deleteRow(row.index)">
                                <i class="fa fa-fw fa-times" />
                            </b-button>
                        </div>
                    </template>
                </b-table>
                <b-row>
                    <b-col md="6">
                        <!-- <b-button variant="dark" @click="addRow" :disabled="isSubmitting"> -->
                        <b-button variant="dark" @click="prepareAddAdjustment"
                            :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment) || isSubmitting">
                            <i class="fa fa-plus mr-2" />Tambah Keterangan
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="confirmAdd(activeItem.id)"
                            :disabled="(activeItem.status == '3' && !activeItem.fixing_adjustment) || isSubmitting">
                            <i class="fa fa-check mr-2" />Simpan
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal v-if="activeItem" id="m-image"
            :title="'Edit Gambar Kerusakan Item ' + activeItem.type + ' (' + activeAdjustment.name + ')'" size="xl"
            @close="onCloseModalImage" no-close-on-backdrop no-close-on-esc hide-footer
            @hidden="stopResumableKerusakan()">
            <b-row>
                <b-col cols="12" lg="8">
                    <div class="media-container">
                        <b-img-lazy v-if="mediaPreview.media == 'image'" class="media-preview"
                            :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                            blank-src="image-loading.gif" block alt="Image Preview"></b-img-lazy>
                        <video v-else-if="mediaPreview.media == 'video'" class="media-preview" controls
                            :key="mediaPreview.url">
                            <source v-if="mediaPreview.type == 'video/webm'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/ogg'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/mp4'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">
                            <source v-else-if="mediaPreview.type == 'video/3gpp'"
                                :src="mediaPreview.status == 'upload' ? mediaPreview.url : $BASE_FILE_PATH + mediaPreview.url"
                                :type="mediaPreview.type">

                            Your browser does not support the video tag.
                        </video>
                        <b-img-lazy v-else class="media-preview" src="/img/img-preview.png" block
                            alt="No Image"></b-img-lazy>
                    </div>
                    <div class="media-scroll">
                        <div class="media-scroll-content" v-for="(media, index) in filterMediaList" :key="'ms-' + index"
                            @click="onClickImage(media.urlCompress)">
                            <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }"
                                :src="media.media == 'video' ? '/img/video-thumbnail.png' : media.status == 'upload' ? media.url : $BASE_FILE_PATH + media.urlCompress"
                                blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy>
                            <!-- <b-img-lazy class="media-scroll-preview" :class="{ active: media.isActive }" src="https://sample-videos.com/img/Sample-png-image-5mb.png" blank-src="/img/image-loading.gif" block :alt="media.altText"></b-img-lazy> -->
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="4" class="border-responsive">
                    <!-- <b-button block variant="success" :disabled="filterMediaList.length >= 10 || isSubmitting"
                        @click="onAddImage">
                        {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                    </b-button> -->

                    <b-button block variant="warning" class="mb-2" @click="onRefreshImage()">
                        Refresh
                    </b-button>

                    <span v-show="!isUploadK" id="uploadFile" class="mb-2">
                        <b-button block variant="success">
                            {{ isSubmitting ? "Menyimpan..." : "Upload Item Gambar / Video Baru" }}
                        </b-button>
                    </span>

                    <div :key="uploadKeyK">
                        <div v-for="item in fileUploadResumableK" :key="item.uniqueIdentifier">
                            <div v-if="item && item.status == 'uploading'">{{ item.fileName || "" }}
                                <uploading style="width:100%" :completedSteps="item.progress" />
                            </div>

                            <div v-if="item && item.status == 'retry'" class="text-center">
                                Sedang menghubungkan kembali, mohon menunggu...
                            </div>

                            <div v-if="item && item.status == 'error'" class="text-center">
                                Mengalami kesalahan, silahkan coba lagi.
                            </div>
                        </div>

                        <div v-if="finalizeBroken" class="text-center">Sedang proses finalisasi, mohon menunggu...</div>
                    </div>
                    <b-button block variant="primary" class="mt-2"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onOpenImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Tampilkan Item di Tab Baru" }}
                    </b-button>
                    <b-button block variant="danger"
                        :disabled="typeof (mediaPreview.url) === 'undefined' || isSubmitting"
                        @click="onDeleteImage(mediaPreview.url)">
                        {{ isSubmitting ? "Menyimpan..." : "Hapus Item" }}
                    </b-button>
                    <div class="mt-3 media-disclaimer">
                        <small>*Jenis item gambar yang dapat diterima oleh sistem adalah format JPG, JPEG, dan
                            PNG.</small><br>
                        <small>*Jenis item video yang dapat diterima oleh sistem adalah format MP4, OGG, dan
                            WEBM.</small><br>
                        <small>*Maksimal ukuran total gambar / video untuk sekali upload sebesar 400MB.</small><br>
                        <small>*Minimal jumlah item gambar / video per inventori sebanyak 1 buah item.</small><br>
                        <small>*Maksimal jumlah item gambar / video per inventori sebanyak 10 buah item.</small>
                    </div>
                </b-col>
            </b-row>
            <!-- <div class="mt-4 text-right">
                <b-button variant="secondary" class="mr-2" :disabled="isSubmitting" @click="$bvModal.hide('m-image')">
                    Batal
                </b-button>
                <b-button variant="primary" :disabled="isSubmitting" @click="onSaveImage">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div> -->
            <input multiple style="opacity: 0; filter:alpha(opacity=0);" ref="fileupload" type="file"
                @change="onUploadImage" accept="image/png, image/jpeg, video/mp4, video/webm, video/ogg">
        </b-modal>

        <!-- <b-modal id="m-code-update-delete" title="Hapus / Ubah Foto" centered no-close-on-backdrop hide-footer
            @shown="$refs.passcode.focus()">
            <b-form-group label="Passcode">
                <b-form-input type="password" ref="passcode" maxlength="10" v-model="passcode"
                    @keydown.enter="getValidationCode" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="getValidationCode">
                    {{ isSubmitting ? "Mengecheck..." : "Submit" }}
                </b-button>
            </div>
        </b-modal> -->

        <!-- Confirmation Modal -->
        <b-modal id="m-confirm" centered hide-footer>
            <template v-slot:modal-title>
                <h4>{{ confirmTitle }}</h4>
            </template>

            <p>{{ confirmMessage }}</p>

            <div class="d-flex justify-content-end">

                <b-button class="mr-2" variant="secondary" @click="$bvModal.hide('m-confirm')">Batal</b-button>
                <b-button variant="primary" @click="submitAction">{{ confirmActionText }}</b-button>
            </div>

        </b-modal>

        <b-modal id="m-add-adjustment" title="Tambah Adjustment" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Jenis Barang">
                <b-form-select v-model="addAdj.kind" :options="addAdj.optKind" disabled />
            </b-form-group>
            <b-form-group label="Kategori Kerusakan">
                <b-form-select v-model="addAdj.category" :options="optCategory" @input="onChangeAdjCategory" />
            </b-form-group>
            <b-form-group label="Keterangan">
                <b-form-select v-model="addAdj.name" :options="addAdj.optAdjustments"
                    :disabled="$helper.isBlank(addAdj.category) || addAdj.optAdjustments.length <= 0" />
            </b-form-group>
            <b-form-group label="Adjustment Harga (Nominal)">
                <b-input-group prepend="Rp.">
                    <b-form-input v-model="addAdj.adjustment" @input="sanitize(addAdj)"
                        :disabled="$helper.isBlank(addAdj.name) || addAdj.adjustmentPercentage != '' || activeItem.fixing_adjustment == 1"
                        maxlength="50" />
                </b-input-group>
            </b-form-group>
            <b-form-group label="Adjustment Harga (Persentase)">
                <b-input-group append="%">
                    <b-form-input v-model="addAdj.adjustmentPercentage"
                        :disabled="$helper.isBlank(addAdj.name) || addAdj.adjustment != '' || activeItem.fixing_adjustment == 1"
                        maxlength="50" />
                </b-input-group>
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmAddAdjustment">
                    {{ isSubmitting ? "Menambah..." : "Tambah" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-update-color" title="Update Warna Barang" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Warna Barang">
                <multiselect v-model="inputColor" label="name" track-by="id" :internal-search="true" deselect-label=""
                    select-label="" :options="optColor" placeholder="Pilih Warna" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmUpdateColor">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>


        <b-modal id="m-capture-camera" title="Capture Camera" no-close-on-backdrop no-close-on-esc hide-footer
            @hidden="onCaptureClose">
            <div class="d-flex justify-content-center">
                <video ref="videoElement" style="width:100%" height="300" autoplay></video>
            </div>
            <!-- switch camera -->
            <div class="d-flex justify-content-center mt-3">
                <b-button variant="primary" @click="switchCamera" :disabled="isSubmitting">
                    <i class="fa fa-fw fa-refresh mr-2" />Switch Camera
                </b-button>
                <b-button class="ml-2" variant="primary" @click="toggleFlash" :disabled="isSubmitting">
                    <i class="fa fa-fw" :class="isFlashOn ? 'fa-lightbulb' : 'fa-lightbulb-o'"></i>
                    {{ isFlashOn ? "Flash On" : "Flash Off" }}
                </b-button>
            </div>
            <div class="mt-4 text-center">
                <b-button block variant="primary" :disabled="isSubmitting" @click="captureCamera()">
                    {{ isSubmitting ? "Menyimpan..." : "Capture" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-reprint-code" title="Reprint Barcode" centered no-close-on-backdrop hide-footer
            @shown="$refs.passcode.focus()">
            <b-form-group label="Passcode Reprint">
                <b-form-input type="password" ref="passcode" maxlength="10" v-model="passcode"
                    @keydown.enter="getReprintBarcode" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="getReprintBarcode">
                    {{ isSubmitting ? "Mengambil..." : "Reprint" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-reprint-barcode" title="Reprint Barcode" no-close-on-backdrop no-close-on-esc hide-footer
            hide-header-close>
            Silahkan cetak barcode dibawah ini. Mohon pastikan barcode tercetak dengan baik sebelum melanjutkan.
            <br /><br />
            <iframe :src="getBarcodeLink()" height="300px" width="100%" />
            <div class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button variant="dark" :disabled="barcodeToggleCooldown" @click="toggleBarcodeType">
                            Print {{ barcodeType == 'barcode' ? 'Kerusakan' : 'Barcode' }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="primary" @click="$bvModal.hide('m-reprint-barcode')">
                            Tutup
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>

        <b-modal id="m-duplicate-imei" title="Pilih Inventaris" size="xl" no-close-on-backdrop no-close-on-esc
            hide-footer>

            <b-table responsive striped hover :items="arrDuplicateImei" :fields="fieldsDuplicate">
                <template v-slot:cell(no_faktur)="{ item }">
                    <strong style="cursor: pointer;">
                        {{ item.no_faktur }}

                        <b-button @click="searcNoDuplicateImei(item)" variant="primary" size="sm">
                            <i class="fa fa-fw fa-search" />
                        </b-button>
                    </strong>
                </template>

                <template v-slot:cell(barang)="{ item }">
                    <strong>{{ item.type || "-" }}</strong>
                    <div>
                        {{ item.kind || "-" }} - {{ item.brand || "-" }}
                    </div>
                </template>

                <template v-slot:cell(delivery)="{ item }">
                    {{ item.source || "-" }} - {{ item.branch || "-" }}
                    <div>
                        {{ $helper.parseDate(item.delivery_date) || "-" }}
                    </div>
                </template>

                <template v-slot:cell(status)="{ item }">
                    <b-badge :variant="parseStatusVariant(item.status)">
                        {{ parseStatusName(item.status) }}
                    </b-badge>
                </template>
            </b-table>

        </b-modal>
    </div>
</template>

<script>
import DetailBarang from './DetailBarang.vue'
import ModalInputBarangMasukExternal from './ModalInputBarangMasukExternal.vue'
import lodash from 'lodash'
import Resumable from 'resumablejs';
import Uploading from "./Uploading.vue"

export default {
    components: {
        DetailBarang,
        ModalInputBarangMasukExternal,
        Uploading
    },
    data() {
        return {

            isSubmitting: false,
            inventoryId: "",
            kindId: "",

            number: "",
            noFaktur: "",

            previewPhoto: null,
            photos: [],
            kategoriFotoOpt: [],
            item: null,
            kategoriFoto: 0,

            activeItem: null,
            activeIndex: null,
            activePhoto: null,
            activeType: null,

            invoiceAdjustments: [],
            optAdjustments: [],
            adjustments: [],

            optCategory: [],

            fieldsAdjust: [
                { key: "category", label: "Kategori", sortable: false, thClass: 'adjust-column-min' },
                { key: "name", label: "Keterangan", sortable: false, thClass: 'adjust-column-min' },
                { key: "adjustment", label: "Potongan / Tambahan Harga (Nominal)", sortable: false },
                { key: "adjustmentPercent", label: "Potongan / Tambahan Harga (Persen)", sortable: false },
                { key: "action", label: "Aksi" },
            ],

            initStatus: 0,
            initTable: 0,
            isLoadingTable: false,
            isBusy: true,
            show: 10,

            isDownloadExcelAllowed: false,
            isMoveInventoryAllowed: false,
            isRequestResetAllowed: false,

            fetchReportStatus: 0,
            reportPath: "",

            activeId: 0,
            passcode: "",
            resetReason: "",
            resetType: "",

            filter: {
                name: "",
                kind: null,
                brand: null,
                itemYear: "",
                spec: null,
                warehouse: null,
                noFaktur: "",
                imeiSn: "",
                grade: [],
                isBatangan: -1,
                status: [],
                from: null,
                to: null
            },

            input: {
                warehouse: 0,
            },

            inputColor: {},

            options: [
                { value: 10, text: '10' },
                { value: 20, text: '20' },
                { value: 30, text: '30' },
                { value: 40, text: '40' },
                { value: 50, text: '50' },
            ],

            fields: [
                { key: "item", label: "Barang", sortable: true },
                { key: "price", label: "Harga Jual", sortable: true },
                { key: "detail", label: "Detail", sortable: true },
                { key: "status", label: "Status", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optKind: [],
            optBrand: [],
            optSpec: [],
            optWarehouse: [],
            optColor: [],

            optGrade: [
                { id: "S", name: "S" },
                { id: "A", name: "A" },
                { id: "B", name: "B" },
                { id: "C", name: "C" },
                { id: "X", name: "X" },
            ],
            optIsBatangan: [
                { value: -1, text: "Semua" },
                { value: 1, text: "Batangan" },
                { value: 0, text: "Lengkap" }
            ],
            optStatus: [
                // { value: -1, text: "Semua" },
                { id: 2, name: "READY" },
                { id: 7, name: "DRAFT" },
                { id: 3, name: "TERJUAL" },
                { id: 4, name: "RETUR" },
                { id: 5, name: "HILANG" },
                { id: 55, name: "REQUEST HILANG" },
                { id: 6, name: "KIRIM BALIK PGI" },
                { id: 66, name: "REQUEST KIRIM BALIK" },
                { id: 8, name: "REQUEST RESET" },
                { id: 9, name: "REQUEST MOVE" }
            ],

            mediaPreview: {},

            mediaList: [],

            isImageChanged: false,

            addAdj: {
                kind: null,
                optKind: [],
                category: null,
                name: null,
                optAdjustments: [],
                adjustment: "",
                adjustmentPercentage: ""
            },

            activeAdjustment: {},

            isChangeAdjustment: false,
            isChangePhotoAdjustment: false,

            prepareImageType: "",

            barcodeLink: "",
            barcodeLinkDamage: "",
            barcodeMoveLink: "",
            barcodeMoveLinkDamage: "",

            barcodeType: 'barcode',
            barcodeMoveType: 'barcode',
            barcodeToggleCooldown: false,

            mediaStream: null,
            indexMedia: 0,
            isFlashOn: false,

            confirmTitle: "",
            confirmMessage: "",
            confirmActionText: "",

            fileUploadResumable: [],
            resumable: false,
            uploadKey: 0,
            isUpload: false,

            fileUploadResumableK: [],
            resumableK: false,
            uploadKeyK: 0,
            isUploadK: false,

            activeAdjustmentRow: null,
            finalizeBroken: false,

            arrDuplicateImei: "",

            fieldsDuplicate: [
                { key: 'no_faktur', label: 'No Faktur', sortable: true },
                { key: 'barang', label: 'Barang', sortable: true },
                { key: 'status', label: 'Status', sortable: true },
                { key: 'delivery', label: 'Pengiriman', sortable: true },
            ],

            optAccessories: []

        }
    },
    methods: {

        parseStatusVariant(status) {

            switch (status) {
                case 1: return "warning"
                case 2: return "success"
                case 5: return "danger"
                default: return "light"
            }

        },

        parseStatusName(status) {

            switch (status) {
                case 1: return "PENDING"
                case 2: return "APPROVED"
                case 5: return "HILANG"
                default: return "LAINNYA"
            }

        },

        searcNoDuplicateImei(item) {
            this.inventoryId = item.id
            this.getItems()
            this.$bvModal.hide("m-duplicate-imei")
        },

        duplicateImeiFetch(imei) {
            this.$axios.get("delivery/inventory/doubleimei/" + imei).then(res => {
                this.arrDuplicateImei = res.data.data

                this.$bvModal.show("m-duplicate-imei")
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        searchNumber() {

            if (this.isSubmitting) return

            this.isSubmitting = true
            this.$axios.get("inventory-photo/get-inventory?number=" + this.number).then(res => {

                if (res.data.data.duplicateImei) {
                    this.noFaktur = ""
                    this.duplicateImeiFetch(this.number)
                } else {
                    this.inventoryId = res.data.data.id
                    this.getItems()
                }


            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        searchNoFaktur() {

            if (this.isSubmitting) return

            this.isSubmitting = true
            this.$axios.get("inventory-photo/get-id-by-no-faktur-for-input?bypassImei=true&number=" + this.noFaktur).then(res => {

                this.inventoryId = res.data.data.id
                this.$bvModal.show("m-detail")

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        // async searchNumber() {

        //     if (this.isSubmitting) return

        //     this.isSubmitting = true
        //     this.$axios.get("inventory-photo/get-inventory?number=" + this.number).then(res => {

        //         this.inventoryId = res.data.data.id

        //         this.getItems()

        //     })
        //         .catch(error => this.$helper.parseError(this, error))
        //         .finally(() => this.isSubmitting = false)

        // },

        // searchNoFaktur() {

        //     if (this.isSubmitting) return

        //     this.isSubmitting = true
        //     this.$axios.get("inventory-photo/get-inventory?bypassImei=true&number=" + this.noFaktur).then(res => {

        //         this.inventoryId = res.data.data.id
        //         this.$bvModal.show("m-detail")

        //     })
        //         .catch(error => this.$helper.parseError(this, error))
        //         .finally(() => this.isSubmitting = false)

        // },

        onApproved() {

            this.$bvModal.hide("m-detail")
            this.$bvModal.hide("m-faktur-hp")
            this.$helper.toastSuccess(this, "IMEI/No.Faktur " + this.number + " berhasil diapprove!")
            this.number = ""
            this.noFaktur = ""

        },

        processLostItem() {

            this.$bvModal.hide("m-detail")
            this.$bvModal.hide("m-faktur-hp")
            this.$helper.toastSuccess(this, "IMEI/No.Faktur " + this.number + " berhasil dinyatakan hilang!")
            this.number = ""
            this.noFaktur = ""

        },

        showBarangExternal() {
            this.$refs.modalInputBarangMasukExternal.$bvModal.show('m-input-barang-masuk-external')
        },

        addPhoto() {

            const kategoriFotoData = this.kategoriFotoOpt.find(item => item.value == this.kategoriFoto)

            this.photos.push({
                id: this.photos.length + 1,
                idCategory: kategoriFotoData.value,
                name: kategoriFotoData.text,
                url: null,
                file: null,
                isVideo: kategoriFotoData.isVideo,
                isAddedServer: false,
                isUploaded: false

            })

            this.kategoriFoto = ""

            setTimeout(() => {
                this.initResumable(this.photos)
            }, 1000)
        },

        onDeletePhoto(index, item) {

            if (item.isAddedServer) {
                this.$axios.get(`delivery/hapus-foto/${item.id}`).then(res => {
                    this.$helper.toastSuccess(this, `Bagian ${item.name} berhasil dihapus`)
                    this.photos.splice(index, 1)
                }).catch(error => this.$helper.parseError(this, error))
            } else {
                this.photos.splice(index, 1)
            }
        },

        onFileChange(index) {
            let file = event.target.files[0]
            this.photos[index].file = file
            this.photos[index].url = URL.createObjectURL(file)
        },

        showPreview(index) {
            this.previewPhoto = this.photos[index]
            this.$bvModal.show("m-preview-photo")
        },

        async getItems() {
            this.onResetPhoto()
            await this.$axios.get("delivery/inventory/" + this.inventoryId).then(res => {
                this.item = res.data.data
                this.kindId = this.item.kind_id
                this.activeItem = res.data.data

                this.getKategoriFotoOpt()
                this.getPhotos()

                this.item.available_specs.forEach(it => {
                    this.optSpec.push({ value: it.id, text: it.name })
                })

                this.input.spec = this.optSpec[0].value || null

                this.item.available_warehouses.forEach(it => {
                    this.optWarehouse.push({ value: it.id, text: it.name })
                })

                this.item.available_accessories.forEach(it => {
                    this.optAccessories.push({ id: it.id, name: it.name })
                })

                this.input.isBatangan = this.item.is_batangan_pgi == true

                this.input.color = this.item.item_color_id

                if (!this.item.has_grade_s) {
                    this.optGrade.shift()
                }

                // let getCategories = this.$axios.get("category/selection?item_kind_id=" + this.item.kind_id).then(res => {
                //     this.optCategory = res.data.data.map(item => {
                //         return {
                //             value: item.id,
                //             text: item.name
                //         }
                //     })
                // })

                let getColors = this.$axios.get("master/color/selection").then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        this.optColor.push({
                            value: res.data.data[i].id,
                            text: res.data.data[i].name
                        })
                    }
                })

                let getAdjustments = this.$axios.get("category/selection?item_kind_id=" + this.item.kind_id).then(res => {
                    this.optCategory = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })
                    let param = "?id=" + this.item.id
                    this.$axios.get("inventory/get-invoice-adjustments" + param).then(res => {
                        for (let i = 0; i < res.data.data.length; i++) {
                            if (res.data.data[i].optAdjustments.length > 0) {
                                for (let j = 0; j < res.data.data[i].optAdjustments.length; j++) {
                                    if (res.data.data[i].optAdjustments[j].id == res.data.data[i].adjustments_id) {
                                        this.invoiceAdjustments.push({
                                            name_placeholder: res.data.data[i].adjustments_name,
                                            name: res.data.data[i].adjustments_name,
                                            category: res.data.data[i].category_id,
                                            adjustmentSelect: {
                                                id: res.data.data[i].optAdjustments[j].id,
                                                name: res.data.data[i].optAdjustments[j].name,
                                                adjustment: res.data.data[i].optAdjustments[j].adjustment,
                                                adjustment_percentage: res.data.data[i].optAdjustments[j].adjustment_percentage
                                            },
                                            adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                            adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                            optAdjustments: res.data.data[i].optAdjustments.map(item => {
                                                return {
                                                    value: {
                                                        id: item.id,
                                                        name: item.name,
                                                        adjustment: item.adjustment,
                                                        adjustment_percentage: item.adjustment_percentage,
                                                    },
                                                    text: item.name
                                                }
                                            })
                                        })
                                        break
                                    }
                                }
                            }
                            else {
                                this.invoiceAdjustments.push({
                                    name_placeholder: res.data.data[i].adjustments_name,
                                    name: res.data.data[i].adjustments_name,
                                    category: res.data.data[i].category_id,
                                    adjustmentSelect: {
                                        id: res.data.data[i].adjustments_id,
                                        name: res.data.data[i].adjustments_name,
                                        adjustment: res.data.data[i].adjustment,
                                        adjustment_percentage: res.data.data[i].adjustment_percentage
                                    },
                                    adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                    adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                    optAdjustments: []
                                })
                            }
                            // diubah sementara supaya adjustment harga bisa diinput manual dulu
                            // this.adjustments.push({
                            //     name: res.data.data[i].adjustments_name,
                            //     adjustmentSelect: {
                            //         id: res.data.data[i].adjustments_id,
                            //         name: res.data.data[i].adjustments_name,
                            //         adjustment: res.data.data[i].adjustment,
                            //         adjustment_percentage: res.data.data[i].adjustment_percentage
                            //     },
                            //     adjustment: res.data.data[i].adjustment,
                            //     adjustmentPercentage: res.data.data[i].adjustment_percentage
                            // })
                        }
                        for (var i = 0; i < this.adjustments.length; i++) {
                            let adj = this.adjustments[i]
                            this.sanitize(adj)
                        }
                        if (this.invoiceAdjustments.length <= 0) this.addRow()
                    })
                        .catch(error => this.$helper.parseError(this, error))
                        .finally(() => this.isSubmitting = false)
                })


                Promise.all([getAdjustments, getColors]).then(res => {
                    this.initStatus = 1
                }).catch(error => {
                    // this.$helper.parseError(this, error)
                    this.initStatus = -1
                })
            })
                .catch(error => {
                    // this.$helper.parseError(this, error)
                    this.initStatus = -1
                })
        },

        async getKategoriFotoOpt() {
            await this.$axios.get(`master/kategori-foto/selection?kind_id=${this.kindId}`).then(res => {
                this.kategoriFotoOpt = res.data.data.filter(item => item.is_required != 1).map(item => {
                    return {
                        value: item.id,
                        text: item.name,
                        isVideo: item.is_video
                    }
                })

                // find photo required
                const photoIsRequired = res.data.data.filter(item => item.is_required == 1)

                photoIsRequired.forEach(item => {
                    this.photos.push({
                        id: item.id,
                        idCategory: item.id,
                        name: item.name,
                        url: null,
                        file: null,
                        isRequired: item.is_required,
                        isVideo: item.is_video,
                        isAddedServer: false,
                        isUploaded: false
                    })
                })

            })
                .catch(error => this.$helper.parseError(this, error))
        },



        async getPhotos() {
            await this.$axios.get('delivery/get-foto/' + this.inventoryId).then(res => {
                let photos = res.data.data

                photos.forEach(photo => {
                    const index = this.photos.findIndex(item => item.id == photo.id_category_photos)

                    // logic if foto already exist
                    if (index >= 0) {

                        this.photos[index].id = photo.id ? photo.id : 0
                        this.photos[index].idCategory = photo.id_category_photos ? photo.id_category_photos : 0
                        this.photos[index].url = this.$BASE_FILE_PATH + photo.path ? this.$BASE_FILE_PATH + photo.path : null
                        this.photos[index].isVideo = false
                        this.photos[index].isAddedServer = true
                    }

                    // logic if foto not exist
                    if (index < 0) {

                        const nameCategory = this.kategoriFotoOpt.find(item => item.value == photo.id_category_photos) || {}

                        this.photos.push({
                            id: photo.id ? photo.id : 0,
                            idCategory: photo.id_category_photos ? photo.id_category_photos : 0,
                            name: nameCategory.text ? nameCategory.text : "-",
                            url: this.$BASE_FILE_PATH + photo.path ? this.$BASE_FILE_PATH + photo.path : null,
                            file: null,
                            isVideo: nameCategory.isVideo ? nameCategory.isVideo : false,
                            isRequired: photo.is_required ? photo.is_required : 0,
                            isAddedServer: true,
                            isUploaded: false
                        })
                    }

                })

                setTimeout(() => {
                    this.initResumable(this.photos)
                }, 1000)

            }).catch(error => this.$helper.parseError(this, error))



        },

        onReset() {
            this.number = ""
            this.noFaktur = ""
            this.item = null
            this.inventoryId = ""
            this.photos = []
            this.isUpload = false

            // Resumable Reset
            this.fileUploadResumable = []
            this.resumable = false

        },

        onResetPhoto() {
            this.photos = []
            this.kategoriFotoOpt = []
        },

        async initialPhotos() {
            await this.getKategoriFotoOpt()
            await this.getPhotos()
        },

        async onSavePhoto(index) {

            const photo = this.photos[index]

            if (!photo.file) {
                this.$helper.toastError(this, `Foto ${photo.name} belum dipilih`)
                return
            }

            // size
            if (photo.isVideo) {
                if (photo.file.type != 'video/mp4') {
                    this.$helper.toastError(this, 'Video harus berupa file video dengan format mp4')
                    return
                }
            } else {
                if (photo.file.type != 'image/jpeg' && photo.file.type != 'image/png' && photo.file.type != 'image/jpg') {
                    this.$helper.toastError(this, 'Foto harus berupa file gambar dengan format jpeg, jpg, atau png')
                    return
                }
            }

            const formData = new FormData()
            formData.append('photos', photo.file)
            formData.append('id_inventory', this.inventoryId)
            formData.append('id_category_photos', photo.idCategory)
            formData.append('size_file', photo.file.size)

            this.photos[index].isUploaded = true
            await this.$axios.post('delivery/input-foto', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                this.photos[index].isUploaded = false
                this.$helper.toastSuccess(this, `Bagian ${photo.name} berhasil diupload`)
                this.photos[index].isAddedServer = true

                this.onResetPhoto()
                this.initialPhotos()

            }).catch(error => this.$helper.parseError(this, error))
        },

        async onUpdatePhoto(index) {
            const photo = this.photos[index]

            if (!photo.file) {
                this.$helper.toastError(this, `Bagian ${photo.name} belum dipilih`)
                return
            }

            if (photo.isVideo) {
                if (photo.file.type != 'video/mp4') {
                    this.$helper.toastError(this, 'Video harus berupa file video dengan format mp4')
                    return
                }
            } else {
                if (photo.file.type != 'image/jpeg' && photo.file.type != 'image/png' && photo.file.type != 'image/jpg') {
                    this.$helper.toastError(this, 'Foto harus berupa file gambar dengan format jpeg, jpg, atau png')
                    return
                }
            }

            const formData = new FormData()
            formData.append('photos', photo.file)
            formData.append('id_inventory', this.inventoryId)
            formData.append('id_category_photos', photo.idCategory)
            formData.append('id_photo', photo.id)
            formData.append('size_file', photo.file.size)

            this.photos[index].isUploaded = true
            await this.$axios.post('delivery/input-foto', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                this.photos[index].isUploaded = false
                this.$helper.toastSuccess(this, `Bagian ${photo.name} berhasil diupload`)
                this.photos[index].isAddedServer = true

                this.onResetPhoto()
                this.initialPhotos()
            }).catch(error => this.$helper.parseError(this, error))
        },


        onCloseModalAdjustment(e) {
            let isConfirmed = confirm("Apakah anda yakin ingin menutup menu Adjustment Barang? Perubahan yang belum disimpan akan hilang.")
            if (!isConfirmed) e.preventDefault()
        },

        prepareAdjustment() {
            this.invoiceAdjustments = []
            this.activeItem = this.item
            this.isSubmitting = true

            this.resumable.files.forEach(file => {
                if (file.uniqueIdentifier === this.fileUploadResumable[index].file.uniqueIdentifier) {
                    file.cancel()
                }
            })

            // this.$axios.get("adjustment/selection?item_kind_id=" + item.kind_id ).then(res => {

            this.$axios.get("category/selection?item_kind_id=" + this.activeItem.kind_id).then(res => {
                this.optCategory = res.data.data.map(item => {
                    return {
                        value: item.id,
                        text: item.name
                    }
                })

                let param = "?id=" + this.item.id
                this.$axios.get("inventory/get-invoice-adjustments" + param).then(res => {
                    for (let i = 0; i < res.data.data.length; i++) {
                        if (res.data.data[i].optAdjustments.length > 0) {
                            for (let j = 0; j < res.data.data[i].optAdjustments.length; j++) {
                                if (res.data.data[i].optAdjustments[j].id == res.data.data[i].adjustments_id) {

                                    this.invoiceAdjustments.push({
                                        name_placeholder: res.data.data[i].adjustments_name,
                                        name: res.data.data[i].adjustments_name,
                                        category: res.data.data[i].category_id,
                                        adjustmentSelect: {
                                            id: res.data.data[i].optAdjustments[j].id,
                                            name: res.data.data[i].optAdjustments[j].name,
                                            adjustment: res.data.data[i].optAdjustments[j].adjustment,
                                            adjustment_percentage: res.data.data[i].optAdjustments[j].adjustment_percentage
                                        },
                                        adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                        adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                        optAdjustments: res.data.data[i].optAdjustments.map(item => {
                                            return {
                                                value: {
                                                    id: item.id,
                                                    name: item.name,
                                                    adjustment: item.adjustment,
                                                    adjustment_percentage: item.adjustment_percentage,
                                                },
                                                text: item.name
                                            }
                                        })
                                    })
                                    break
                                }
                            }
                        }
                        else {
                            this.invoiceAdjustments.push({
                                name_placeholder: res.data.data[i].adjustments_name,
                                name: res.data.data[i].adjustments_name,
                                category: res.data.data[i].category_id,
                                adjustmentSelect: {
                                    id: res.data.data[i].adjustments_id,
                                    name: res.data.data[i].adjustments_name,
                                    adjustment: res.data.data[i].adjustment,
                                    adjustment_percentage: res.data.data[i].adjustment_percentage
                                },
                                adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                optAdjustments: []
                            })
                        }
                        // diubah sementara supaya adjustment harga bisa diinput manual dulu
                        // this.invoiceAdjustments.push({
                        //     name: res.data.data[i].adjustments_name,
                        //     adjustmentSelect: {
                        //         id: res.data.data[i].adjustments_id,
                        //         name: res.data.data[i].adjustments_name,
                        //         adjustment: res.data.data[i].adjustment,
                        //         adjustment_percentage: res.data.data[i].adjustment_percentage
                        //     },
                        //     adjustment: res.data.data[i].adjustment,
                        //     adjustmentPercentage: res.data.data[i].adjustment_percentage
                        // })
                    }

                    for (var i = 0; i < this.invoiceAdjustments.length; i++) {

                        let adj = this.invoiceAdjustments[i]

                        this.sanitize(adj)

                    }

                    this.$bvModal.show("m-item-to-adjust")
                    this.isChangeAdjustment = false
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })

        },

        sanitize(item) {
            let cleaned = String(item.adjustment).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item.adjustment = res
        },

        onChangeRowCategory(index) {

            this.invoiceAdjustments[index].name = ""
            this.invoiceAdjustments[index].adjustmentSelect = null
            this.invoiceAdjustments[index].optAdjustments = []

            if (!this.$helper.isBlank(this.invoiceAdjustments[index].category)) {
                let param = "?item_kind_id=" + this.item.kind_id
                param += "&category_id=" + this.invoiceAdjustments[index].category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.invoiceAdjustments[index].optAdjustments = res.data.data.map(item => {
                        return {
                            value: {
                                id: item.id,
                                name: item.name,
                                adjustment: item.adjustment,
                                adjustment_percentage: item.adjustment_percentage,
                            },
                            text: item.name
                        }
                    })
                    this.isSubmitting = false
                })
            }
        },

        deleteRow(index) {
            this.invoiceAdjustments.splice(index, 1)
            this.isChangeAdjustment = true
        },

        prepareAdjImage(item) {
            this.activeAdjustmentRow = item
            this.mediaPreview = {}
            this.mediaList = []
            this.activeAdjustment = item.adjustmentSelect
            this.isSubmitting = true
            let param = "?inventory_id=" + this.activeItem.id
            param += "&adjustment_id=" + this.activeAdjustment.id
            this.$axios.get("adjustment-damaged-photo" + param).then(res => {
                for (let i = 0; i < res.data.data.length; i++) {
                    let fileMedia = ''
                    let fileAltText = ''
                    if (res.data.data[i].type == 'image/jpeg' || res.data.data[i].type == 'image/png') {
                        fileMedia = 'image'
                        fileAltText = 'Upload Image Preview'
                    }
                    else if (res.data.data[i].type == 'video/mp4' || res.data.data[i].type == 'video/webm' || res.data.data[i].type == 'video/ogg' || res.data.data[i].type == 'video/3gpp') {
                        fileMedia = 'video'
                        fileAltText = 'Upload Video Preview'
                    }
                    else {
                        continue
                    }
                    let filenameSplit = res.data.data[i].path.split('/')
                    filenameSplit = filenameSplit[filenameSplit.length - 1].split('.')
                    let fileExtension = filenameSplit.pop()
                    let filename = filenameSplit.join()
                    this.mediaList.push({
                        id: res.data.data[i].id,
                        media: fileMedia,
                        type: res.data.data[i].type,
                        filename: filename,
                        extension: fileExtension,
                        url: res.data.data[i].path,
                        urlCompress: this.modifyPathCompress(res.data.data[i].path_compress),
                        altText: fileAltText,
                        status: 'get',
                        isActive: false,
                        file: null
                    })
                }
                this.isImageChanged = false
                this.$bvModal.show("m-image")

                setTimeout(() => {
                    this.initResumableK()
                }, 1000)
            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },
        onCloseModalImage(e) {
            // if (this.isImageChanged) {
            //     let isConfirmed = confirm("Apakah anda yakin ingin menutup menu Gambar Kerusakan? Perubahan yang belum disimpan akan hilang.")
            //     if (!isConfirmed) e.preventDefault()
            // }
        },

        prepareAddAdjustment() {
            this.addAdj.optKind = [
                { value: this.activeItem.kind_id, text: this.activeItem.kind }
            ]
            this.addAdj.kind = this.activeItem.kind_id
            this.addAdj.category = null
            this.addAdj.optAdjustments = []
            this.addAdj.name = null
            if (this.activeItem.fixing_adjustment) {
                this.addAdj.adjustment = "0"
                this.addAdj.adjustmentPercentage = ""
            } else {
                this.addAdj.adjustment = ""
                this.addAdj.adjustmentPercentage = ""
            }
            this.$bvModal.show("m-add-adjustment")
        },
        changeAdjustment() {
            this.isChangeAdjustment = true
        },

        onClickImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                this.mediaList[i].isActive = false
                if (this.mediaList[i].urlCompress == url) {
                    this.mediaList[i].isActive = true
                    this.mediaPreview = lodash.cloneDeep(this.mediaList[i])
                }
            }
        },

        onAddImage() {
            this.$refs.fileupload.click()
            this.isChangePhotoAdjustment = true
        },

        onUploadImage(e) {
            var files = e.target.files || e.dataTransfer.files
            if (!files.length) return
            // else if(files[0].size > this.$uploadLimit) {
            //     return
            // }
            if (this.filterMediaList.length + files.length > 10) {
                this.$helper.toastError(this, "Operasi Upload Dibatalkan! Jumlah gambar / video melebihi kapasitas maksimal 10 item per inventori.")
                return
            }
            for (let i = 0; i < files.length; i++) {
                let fileMedia = ''
                let fileAltText = ''
                if (files[i].type == 'image/jpeg' || files[i].type == 'image/png') {
                    fileMedia = 'image'
                    fileAltText = 'Upload Image Preview'
                }
                else if (files[i].type == 'video/mp4' || files[i].type == 'video/webm' || files[i].type == 'video/ogg') {
                    fileMedia = 'video'
                    fileAltText = 'Upload Video Preview'
                }
                else {
                    this.$helper.toastError(this, "Upload Item Gagal! Jenis file " + files[i].name + " tidak dikenali oleh sistem.")
                    continue
                }
                let filenameSplit = files[i].name.split('.')
                let fileExtension = filenameSplit.pop()
                let filename = filenameSplit.join()
                let fileResult = {
                    id: null,
                    media: fileMedia,
                    type: files[i].type,
                    filename: filename,
                    extension: fileExtension,
                    url: URL.createObjectURL(files[i]),
                    altText: fileAltText,
                    status: 'upload',
                    isActive: false,
                    file: files[i]
                }
                this.mediaList.push(fileResult)
                // for(let i = 0; i < this.mediaList.length; i++){
                //     this.mediaList[i].isActive = false
                // }
                // this.mediaPreview = lodash.cloneDeep(fileResult)
                this.isImageChanged = true
                this.$helper.toastSuccess(this, "Upload " + files[i].name + " berhasil!")
            }
            this.$refs.fileupload.value = null
        },

        onOpenImage(url) {
            window.open(this.$BASE_FILE_PATH + url, '_blank')
        },

        onDeleteImage(url) {
            for (let i = 0; i < this.mediaList.length; i++) {
                if (this.mediaList[i].url == url) {
                    if (this.mediaList[i].status == 'get') {
                        this.mediaList[i].status = 'delete'

                        let payload = new FormData()

                        payload.append("inventory_id", this.inventoryId)
                        payload.append("id_photo", this.mediaList[i].id)

                        this.$axios.post("adjustment-damaged-photo/delete", payload).then(_ => {
                            this.$helper.toastSuccess(this, "Hapus Gambar Berhasil!")
                            // this.$bvModal.hide("m-image")
                            if (this.isChangePhotoAdjustment) {
                                this.isChangeAdjustment = true
                            }

                        })
                            .catch(error => this.$helper.parseError(this, error))
                    }
                    else {
                        this.mediaList.splice(i, 1)
                    }
                    this.isImageChanged = true
                    break
                }
            }
            this.mediaPreview = {}
            this.isChangePhotoAdjustment = true
        },

        // onSaveImage(id) {
        onSaveImage() {

            // if(this.filterMediaList.length < 1 && this.filterMediaList.length != 0){
            //     this.$helper.toastError(this, "Operasi Save Dibatalkan! Jumlah gambar / video kurang dari batas minimal 1 item per inventori.")
            //     return
            // }

            if (this.filterMediaList.length > 10) {
                this.$helper.toastError(this, "Operasi Save Dibatalkan! Jumlah gambar / video melebihi kapasitas maksimal 10 item per inventori.")
                return
            }

            this.isSubmitting = true

            let payload = new FormData()

            let uploadData = this.mediaList.filter(item => item.status == 'upload')
            let deleteData = this.mediaList.filter(item => item.status == 'delete')

            let totalSize = 0

            for (let i = 0; i < this.fileUploadResumableK.length; i++) {
                totalSize += this.fileUploadResumableK[i].file.size
                if (totalSize > 419430400) {
                    this.$helper.toastError(this, "Operasi Save Dibatalkan! Total ukuran gambar / video melebihi kapasitas maksimal 400MB untuk sekali upload.")
                    return
                }
                payload.append("url[]", this.fileUploadResumableK[i].url)
                payload.append("fileName[]", this.fileUploadResumableK[i].fileNameUrl)
            }

            for (let i = 0; i < deleteData.length; i++) {
                payload.append("deletes[]", deleteData[i].id)
            }

            payload.append("inventory_id", this.activeItem.id)
            payload.append("adjustment_id", this.activeAdjustment.id)

            this.$axios.post("adjustment-damaged-photo/update", payload).then(_ => {

                this.$helper.toastSuccess(this, "Update Gambar Berhasil!")
                this.$bvModal.hide("m-image")
                if (this.isChangePhotoAdjustment) {
                    this.isChangeAdjustment = true
                }

            })
                .catch(error => {
                    this.$helper.toastError(this, "Operasi Save Gagal!")
                    this.$bvModal.hide("m-image")
                    this.initResumableK()
                })
                .finally(() => {
                    this.isSubmitting = false
                    this.finalizeBroken = false
                })

        },

        onSaveImageFisik(id) {

            if (this.filterMediaList.length > 10) {
                this.$helper.toastError(this, "Operasi Save Dibatalkan! Jumlah gambar melebihi kapasitas maksimal 10 item per inventori.")
                return
            }

            this.isSubmitting = true

            let payload = new FormData()

            let uploadData = this.mediaList.filter(item => item.status == 'upload')
            let deleteData = this.mediaList.filter(item => item.status == 'delete')

            let totalSize = 0

            for (let i = 0; i < uploadData.length; i++) {
                totalSize += uploadData[i].file.size
                if (totalSize > 419430400) {
                    this.$helper.toastError(this, "Operasi Save Dibatalkan! Total ukuran gambar melebihi kapasitas maksimal 400MB untuk sekali upload.")
                    return
                }
                payload.append("uploads[]", uploadData[i].file)
            }

            for (let i = 0; i < deleteData.length; i++) {
                payload.append("deletes[]", deleteData[i].id)
            }

            payload.append("inventory_id", this.activeItem.id)

            this.$axios.post("inventory-photo/update", payload).then(_ => {

                this.$helper.toastSuccess(this, "Update Gambar Fisik Berhasil!")
                this.$bvModal.hide("m-image-old")

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        async submitAction() {

            this.$bvModal.hide("m-confirm")

            if (this.activeType == 'update') {
                this.onUpdatePhoto(this.activeIndex)
            }

            if (this.activeType == 'delete') {
                this.stopResumableByIndex(this.activeIndex)
                this.onDeletePhoto(this.activeIndex, this.activePhoto)
            }

        },

        confirmAction(index, photo, type) {
            this.activeIndex = index
            this.activePhoto = photo
            this.activeType = type

            if (type == 'update') {
                this.confirmTitle = "Update Foto"
                this.confirmMessage = "Apakah anda yakin ingin mengupdate foto ini?"
                this.confirmActionText = "Update"
            }

            if (type == 'delete') {
                this.confirmTitle = "Hapus Foto"
                this.confirmMessage = "Apakah anda yakin ingin menghapus foto ini?"
                this.confirmActionText = "Hapus"
            }

            this.$bvModal.show("m-confirm")
        },

        onChangeAdjCategory() {
            this.addAdj.name = null
            this.addAdj.optAdjustments = []
            if (!this.$helper.isBlank(this.addAdj.category)) {
                let param = "?item_kind_id=" + this.activeItem.kind_id
                param += "&category_id=" + this.addAdj.category
                this.isSubmitting = true
                this.$axios.get("adjustment/selection-category" + param).then(res => {
                    this.addAdj.optAdjustments = res.data.data.map(item => {
                        return {
                            value: item.id,
                            text: item.name
                        }
                    })
                    this.isSubmitting = false
                })
            }
        },

        confirmAdd(id) {

            let confirmable = true

            for (var i = 0; i < this.invoiceAdjustments.length; i++) {

                let adj = this.invoiceAdjustments[i]

                if (this.$helper.isBlank(adj.adjustmentSelect) || (this.$helper.isBlank(adj.adjustment) && this.$helper.isBlank(adj.adjustmentPercentage)) || this.$helper.isBlank(adj.adjustmentSelect.id)) {
                    confirmable = false
                    return this.$helper.toastError(this, "Terdapat data adjustment yang kosong, mohon dilengkapi!")
                }

            }

            if (confirmable) {
                let payload = new FormData()
                let jsonData = {
                    adjInvoice: this.invoiceAdjustments.map(it => {
                        if (this.$helper.isBlank(it.adjustmentPercentage)) {
                            return {
                                name: it.adjustmentSelect.name,
                                adjustment: this.$helper.toNumber(it.adjustment),
                                adjustmentPercentage: null,
                                adjustment_id: it.adjustmentSelect.id
                            }
                        }
                        else {
                            return {
                                name: it.adjustmentSelect.name,
                                adjustment: parseInt(this.activeItem.final_price * parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', '')) / 100),
                                adjustmentPercentage: Number(parseFloat(it.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2),
                                adjustment_id: it.adjustmentSelect.id
                            }
                        }
                    })
                }

                payload.append("data", JSON.stringify(jsonData))
                payload.append("id", id)
                payload.append("changed", this.isChangeAdjustment)

                this.isSubmitting = true
                this.$axios.post("inventory/update-invoice-adjustments", payload).then(res => {
                    this.$helper.toastSuccess(this, "Update Adjustment Berhasil!")
                    this.$bvModal.hide("m-item-to-adjust")
                    this.getItems(this.currentPage)
                })
                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)
            }

        },

        confirmAddAdjustment() {
            if (this.$helper.isBlank(this.addAdj.name)) {
                this.$helper.toastError(this, "Data Keterangan Adjustment Kerusakan tidak boleh kosong !")
                return
            }

            if (this.$helper.isBlank(this.addAdj.adjustment) && this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                if (!this.activeItem.fixing_adjustment) {
                    this.$helper.toastError(this, "Salah satu dari data Adjustment Nominal atau Persentase tidak boleh kosong !")
                    return
                }
            }

            let payload = new FormData()

            payload.append("inventory_id", this.activeItem.id)
            payload.append("adjustment_id", this.addAdj.name)
            if (this.$helper.isBlank(this.addAdj.adjustmentPercentage)) {
                payload.append("adjustment", this.$helper.toNumber(this.addAdj.adjustment))
            }
            else {
                payload.append("adjustment", parseInt(this.activeItem.final_price * parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', '')) / 100))
                payload.append("adjustment_percentage", Number(parseFloat(this.addAdj.adjustmentPercentage.replace(',', '.').replace(' ', ''))).toFixed(2))
            }

            this.isSubmitting = true
            this.$axios.post("inventory/add-invoice-adjustments", payload).then(res => {

                let param = "?id=" + this.activeItem.id
                this.$axios.get("inventory/get-latest-invoice-adjustment" + param).then(res => {
                    //                    this.invoiceAdjustments = []
                    for (let i = 0; i < res.data.data.length; i++) {
                        if (res.data.data[i].optAdjustments.length > 0) {
                            for (let j = 0; j < res.data.data[i].optAdjustments.length; j++) {
                                if (res.data.data[i].optAdjustments[j].id == res.data.data[i].adjustments_id) {
                                    this.invoiceAdjustments.push({
                                        name: res.data.data[i].adjustments_name,
                                        category: res.data.data[i].category_id,
                                        adjustmentSelect: {
                                            id: res.data.data[i].optAdjustments[j].id,
                                            name: res.data.data[i].optAdjustments[j].name,
                                            adjustment: res.data.data[i].optAdjustments[j].adjustment,
                                            adjustment_percentage: res.data.data[i].optAdjustments[j].adjustment_percentage
                                        },
                                        adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                        adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                        optAdjustments: res.data.data[i].optAdjustments.map(item => {
                                            return {
                                                value: {
                                                    id: item.id,
                                                    name: item.name,
                                                    adjustment: item.adjustment,
                                                    adjustment_percentage: item.adjustment_percentage,
                                                },
                                                text: item.name
                                            }
                                        })
                                    })
                                    break
                                }
                            }
                        }
                        else {
                            this.invoiceAdjustments.push({
                                name: res.data.data[i].adjustments_name,
                                category: res.data.data[i].category_id,
                                adjustmentSelect: {
                                    id: res.data.data[i].adjustments_id,
                                    name: res.data.data[i].adjustments_name,
                                    adjustment: res.data.data[i].adjustment,
                                    adjustment_percentage: res.data.data[i].adjustment_percentage
                                },
                                adjustment: res.data.data[i].adjustment_percentage ? "" : res.data.data[i].adjustment,
                                adjustmentPercentage: res.data.data[i].adjustment_percentage,
                                optAdjustments: []
                            })
                        }
                        // diubah sementara supaya adjustment harga bisa diinput manual dulu
                        // this.invoiceAdjustments.push({
                        //     name: res.data.data[i].adjustments_name,
                        //     adjustmentSelect: {
                        //         id: res.data.data[i].adjustments_id,
                        //         name: res.data.data[i].adjustments_name,
                        //         adjustment: res.data.data[i].adjustment,
                        //         adjustment_percentage: res.data.data[i].adjustment_percentage
                        //     },
                        //     adjustment: res.data.data[i].adjustment,
                        //     adjustmentPercentage: res.data.data[i].adjustment_percentage
                        // })
                    }

                    for (var i = 0; i < this.invoiceAdjustments.length; i++) {

                        let adj = this.invoiceAdjustments[i]

                        this.sanitize(adj)

                    }

                    this.$bvModal.hide("m-add-adjustment")
                    this.isChangeAdjustment = true
                })

                    .catch(error => this.$helper.parseError(this, error))
                    .finally(() => this.isSubmitting = false)

            })
                .catch(error => {
                    this.$helper.parseError(this, error)
                    this.isSubmitting = false
                })
        },

        confirmUpdateColor() {
            if (this.inputColor.id == null) {
                return this.$helper.toastError(this, "Warna barang tidak boleh kosong!")
            }

            let payload = {
                id: this.activeItem.id,
                color: this.inputColor.id
            }

            this.isSubmitting = true
            this.$axios.post("inventory/update-color", payload).then(res => {

                this.$helper.toastSuccess(this, "Update warna berhasil dilakukan!")
                this.$bvModal.hide("m-update-color")
                this.activeItem = {}
                this.inputColor = {}
                this.getItems(this.currentPage)

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)
        },

        onCapture(index) {

            this.$bvModal.show("m-capture-camera")
            this.indexMedia = index
            const this_ = this

            navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: 'environment'
                }
            })
                .then(function (stream) {

                    if (this_.$refs.videoElement) {
                        this_.$refs.videoElement.srcObject = stream;
                    }

                    this_.mediaStream = stream;
                })
                .catch(function (error) {
                    console.error('Error accessing the camera: ', error);
                });

        },

        captureCamera() {

            const videoElement = this.$refs.videoElement;
            const canvas = document.createElement('canvas');
            canvas.width = videoElement.videoWidth;
            canvas.height = videoElement.videoHeight;
            const context = canvas.getContext('2d');
            context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

            context.font = "20px Arial";
            context.fillStyle = "white";
            context.textAlign = "center";
            context.fillStyle = "rgba(0, 0, 0, 0.5)";
            context.fillRect(0, canvas.height - 30, canvas.width, 30);
            context.fillStyle = "white";
            context.fillText(this.$helper.formatDate(new Date()), canvas.width / 2, canvas.height - 10);

            const imageUrl = canvas.toDataURL('image/jpeg');

            // convert base64 to file
            const file = this.$helper.base64ToFile(imageUrl, 'image.jpg')

            // Hentikan aliran media saat modal ditutup
            if (this.mediaStream) {
                this.mediaStream.getTracks().forEach(track => track.stop());
                this.mediaStream = null; // Reset the mediaStream property
            }

            this.photos[this.indexMedia].file = file
            this.photos[this.indexMedia].url = imageUrl

            this.isFlashOn = false

            this.$bvModal.hide("m-capture-camera")

        },

        onCaptureClose() {
            if (this.mediaStream) {
                this.mediaStream.getTracks().forEach(function (track) {
                    track.stop();
                });
            }
            this.mediaStream = null;
            this.isFlashOn = false
            this.$bvModal.hide("m-capture-camera")
        },

        async switchCamera() {
            const videoElement = this.$refs.videoElement;
            const videoTracks = this.mediaStream.getVideoTracks();
            const isFront = videoTracks[0].label.includes('front');
            const videoConstraints = {
                facingMode: isFront ? 'environment' : 'user',
            };
            this.mediaStream.getTracks().forEach(track => track.stop());
            const newStream = await navigator.mediaDevices.getUserMedia({
                video: videoConstraints,
            });
            videoElement.srcObject = newStream;
            this.mediaStream = newStream;
        },
        toggleFlash() {
            const videoElement = this.$refs.videoElement;
            const videoTracks = this.mediaStream.getVideoTracks();
            const track = videoTracks[0];
            const capabilities = track.getCapabilities()
            if (capabilities.torch) {
                track.applyConstraints({
                    advanced: [{ torch: !this.isFlashOn }],
                });
                this.isFlashOn = !this.isFlashOn;
            }
        },

        prepareReprint() {
            this.$bvModal.show("m-reprint-code")
        },

        getReprintBarcode() {

            this.isSubmitting = true
            let payload = {
                id: this.item.id,
                passcode: this.passcode
            }

            this.$axios.post("inventory/reprint-barcode", payload).then(res => {

                this.barcodeLink = res.data.data.link
                this.barcodeLinkDamage = res.data.data.linkDamage
                this.$bvModal.hide("m-reprint-code")
                this.$bvModal.show("m-reprint-barcode")
                this.passcode = ""

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        getBarcodeLink() {
            if (this.barcodeType == 'barcode') {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLink}`
            }
            else {
                return `${this.$BASE_PRINT_FILE_PATH}${this.barcodeLinkDamage}`
            }
        },

        toggleBarcodeType() {
            this.barcodeToggleCooldown = true
            if (this.barcodeType == 'barcode') this.barcodeType = 'damage'
            else this.barcodeType = 'barcode'
            setTimeout(function () {
                this.barcodeToggleCooldown = false
            }.bind(this), 2000);
        },

        modifyPathCompress(path) {
            if (/\/storage\//.test(path)) {
                return path;
            } else {
                return `/storage/${path}`;
            }
        },

        // finds the file in the local files array
        findFile(file) {
            return this.fileUploadResumable.find(item => item.id === file.container.parentNode.id && item.status !== 'canceled') || {}
        },
        initResumable(photos) {
            // init resumablejs on mount
            this.resumable = new Resumable({
                target: this.$BASE_UPLOAD_PATH,
                fileType: ['mp4', 'mov', 'png', 'jpg', 'jpeg'],
                chunkSize: 1 * 1024 * 1024,
                headers: {
                    'Accept': 'application/json'
                },
                query: {
                    feature: "invtrypht",
                    no_faktur: this.item.no_faktur
                },
                maxFiles: 1,
                chunkRetryInterval: 5000,
                maxChunkRetries: 5,
                testChunks: false,
            });

            // Resumable.js isn't supported, fall back on a different method
            if (!this.resumable.support) return alert('Your browser doesn\'t support chunked uploads. Get a better browser.');

            // Looping through photos and assigning drop/browse zones
            photos.forEach((photo, index) => {
                const dropzoneElement = document.getElementById('uploadFile-' + index);

                if (dropzoneElement) {
                    this.resumable.assignBrowse(dropzoneElement);
                    this.resumable.assignDrop(dropzoneElement);

                    this.fileUploadResumable.push('')
                } else {
                    console.warn(`Element with ID 'uploadFile${index}' not found.`);
                }
            });

            let that = this

            // set up event listeners to feed into vues reactivity
            this.resumable.on('fileAdded', (file, event) => {
                file.hasUploaded = false

                // get id container
                const id = event.target.parentNode.id

                // get index form id
                const index = Number(id.split('-')[1])

                const currentPhoto = photos[index]

                // get extension file video or image
                const fileExtension = file.file.type.split('/')[0]

                if ((fileExtension == 'video') && !currentPhoto.isVideo) {
                    this.$helper.toastError(this, `File ${file.file.name} tidak sesuai dengan tipe file yang diizinkan`)
                    return
                }

                if ((fileExtension == 'image') && currentPhoto.isVideo) {
                    this.$helper.toastError(this, `File ${file.file.name} tidak sesuai dengan tipe file yang diizinkan`)
                    return
                }

                if (fileExtension == 'video') {
                    this.resumable.opts.chunkSize = parseInt(this.item.size_upload_video) * 1024
                } else {
                    this.resumable.opts.chunkSize = parseInt(this.item.size_upload_foto) * 1024
                }

                that.fileUploadResumable[index] = {
                    file: file,
                    uniqueIdentifier: file.uniqueIdentifier || "",
                    status: 'uploading',
                    progress: 0,
                    id: id,
                    idCategory: currentPhoto.idCategory,
                    idPhoto: currentPhoto.id,
                    name: currentPhoto.name,
                    url: currentPhoto.url
                }

                this.isUpload = true
                this.resumable.upload()
                this.uploadKey += 1
            })

            this.resumable.on('fileSuccess', (file, event) => {
                this.findFile(file).status = 'success'

                const findFileData = this.findFile(file)

                const jsonParse = JSON.parse(event)

                const formData = new FormData()
                formData.append('id_inventory', this.inventoryId)
                formData.append('id_category_photos', findFileData.idCategory)
                formData.append('size_file', file.file.size)
                formData.append('file_name', jsonParse.data.filename)
                formData.append('url', jsonParse.data.path)

                if (findFileData.url) {
                    formData.append('id_photo', findFileData.idPhoto)
                }

                this.findFile(file).status = 'finalizing'
                this.$axios.post('delivery/input-foto', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    this.$helper.toastSuccess(this, `Bagian ${findFileData.name} berhasil diupload`)

                    this.onResetPhoto()
                    this.initialPhotos()

                }).catch(error => {
                    this.$helper.toastError(this, `Bagian ${findFileData.name} gagal diupload`)
                })
                    .finally(() => {
                        this.isUpload = false
                        this.findFile(file).status = ''
                    })

            })
            this.resumable.on('fileError', (file) => {
                this.findFile(file).status = 'error'
                this.uploadKey += 1
            })
            this.resumable.on('fileRetry', (file) => {
                this.findFile(file).status = 'retry'
                this.uploadKey += 1
            })
            this.resumable.on('fileProgress', (file) => {

                const fileUpload = this.findFile(file)

                if (fileUpload.status !== 'canceled') {
                    this.isUpload = true
                    fileUpload.status = 'uploading'
                    fileUpload.progress = Math.round(file.progress() * 100)
                }

                this.uploadKey += 1
            })
        },
        handleBeforeUnload(event) {
            if (this.isUpload) {
                event.preventDefault();
                event.returnValue = ''; // Beberapa browser membutuhkan returnValue di-set ke string kosong
            }
        },
        // finds the file in the local files array
        findFileK(file) {
            return this.fileUploadResumableK.find(item => item.uniqueIdentifier === file.uniqueIdentifier && item.status !== 'canceled') || {}
        },
        initResumableK() {
            // init resumablejs on mount
            this.resumableK = new Resumable({
                target: this.$BASE_UPLOAD_PATH,
                fileType: ['mp4', 'mov', 'png', 'jpg', 'jpeg'],
                chunkSize: parseInt(this.item.size_upload_foto) * 1024,
                headers: {
                    'Accept': 'application/json'
                },
                query: {
                    feature: "adjdmgpht",
                },
                testChunks: false,
                throttleProgressCallbacks: 1,
                chunkRetryInterval: 5000,
            });

            // Resumable.js isn't supported, fall back on a different method
            if (!this.resumableK.support) return alert('Your browser doesn\'t support chunked uploads. Get a better browser.');

            this.resumableK.assignBrowse(document.getElementById('uploadFile'));
            this.resumableK.assignDrop(document.getElementById('uploadFile'));

            let that = this

            // set up event listeners to feed into vues reactivity
            this.resumableK.on('fileAdded', (file, event) => {
                file.hasUploaded = false
                this.isUploadK = true

                that.fileUploadResumableK.push({
                    file: file,
                    fileName: file.fileName,
                    uniqueIdentifier: file.uniqueIdentifier || "",
                    status: 'uploading',
                    progress: 0,
                    url: "",
                    fileNameUrl: ""
                })

                this.resumableK.upload()

                this.uploadKeyK += 1
            })

            this.resumableK.on('complete', async () => {
                this.finalizeBroken = true
                await this.onSaveImage()
                this.isUploadK = false
                that.fileUploadResumableK = []
                this.uploadKeyK += 1

            })

            this.resumableK.on('fileSuccess', (file, event) => {
                let response = JSON.parse(event)

                this.findFileK(file).status = 'success'
                this.findFileK(file).url = response.data.path || ""
                this.findFileK(file).fileNameUrl = response.data.filename || ""

                this.uploadKeyK += 1
            })
            this.resumableK.on('fileError', (file) => {
                this.findFileK(file).status = 'error'
                this.uploadKeyK += 1
            })
            this.resumableK.on('fileRetry', (file) => {
                this.findFileK(file).status = 'retry'
                this.uploadKeyK += 1
            })
            this.resumableK.on('fileProgress', (file) => {

                const fileUpload = this.findFileK(file)

                if (fileUpload.status !== 'canceled') {
                    fileUpload.status = 'uploading'
                    fileUpload.progress = Math.floor(file.progress() * 100)
                }

                this.uploadKeyK += 1

            })
        },
        onRefreshImage() {
            this.prepareAdjImage(this.activeAdjustmentRow)
        },
        stopResumableKerusakan() {
            this.resumableK.files.forEach(file => {
                file.cancel()
            })
        },
        stopResumable() {
            this.resumable.files.forEach(file => {
                file.cancel()
            })

            this.isUpload = false
        },
        stopResumableByIndex(index) {
            this.resumable.files.forEach(file => {
                if (file.uniqueIdentifier === this.fileUploadResumable[index].file.uniqueIdentifier) {
                    file.cancel()
                }
            })

            this.isUpload = false
        },

    },
    computed: {
        filterMediaList() {
            return this.mediaList.filter(item => item.status != 'delete')
        },
    },
    created() {
        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    destroyed() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },
    beforeRouteLeave(to, from, next) {
        if (this.isUpload) {
            // Show a confirmation dialog to the user
            const answer = window.confirm('You have unsaved changes. Do you really want to leave?');
            if (answer) {
                this.stopResumable()
                next(); // Allow navigation
            } else {
                next(false); // Prevent navigation
            }
        } else {
            next(); // Allow navigation if there are no unsaved changes
        }
    },


}
</script>

<style scoped>
.upload-section {
    border: 1px solid #20A8D7;
    padding: 20px;
    border-radius: 5px;
}

.preview-photo div {
    /* max-width: 210px; */
    width: 100%;
    height: 125px;
    border: 1px solid #20A8D7;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    color: #20A8D7;
    padding: 10px;
    margin-bottom: 5px;
}

.preview-photo div img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.preview-photo div video {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.custom-file-upload {
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    border: 1px solid #20A8D7;
    border-radius: 5px;
    color: #20A8D7;
    text-align: center;
}

.custom-file-upload input[type="file"] {
    display: none;
}

/deep/ .adjust-column-min {
    min-width: 200px;
}

.media-container {
    height: 0;
    padding-top: 56.25%;
    position: relative;
}

.media-preview {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border: 1px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    left: 50%;
    transform: translateX(-50%);
}

:not(:root):-webkit-full-screen {
    object-fit: contain !important;
}

.media-scroll {
    margin-top: 10px;
    height: 70px;
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    background-color: #dee2e6;
    white-space: nowrap;
}

.media-scroll-content {
    display: inline-block !important;
    height: 100%;
    width: 20%;
}

.media-scroll-preview.active {
    border: 5px solid #65c2e4;
}

.media-scroll-preview:hover {
    opacity: 0.5;
}

.media-scroll-preview {
    height: 100%;
    width: 100%;
    border: 5px solid #dee2e6;
    border-radius: .25rem;
    object-fit: cover;
    background-color: #dee2e6;
    cursor: pointer;
}

.border-responsive {
    margin-top: 10px;
    border-top: 1px solid #c8ced3;
}

.media-disclaimer {
    text-align: justify;
    text-justify: inter-word;
}

@media only screen and (min-width: 576px) {
    .media-scroll {
        height: 100px;
    }
}

@media only screen and (min-width: 992px) {
    .border-responsive {
        margin-top: 0px;
        border-top: none;
        border-left: 1px solid #c8ced3;
    }
}

@media only screen and (min-width: 1200px) {
    .media-scroll {
        height: 150px;
    }
}
</style>
